import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { HomePageFeedCompletedCards } from '../components/engagement-section/home-page-constants';
import { saveUserSetting } from '../../../store/user/user.actions';
import { useUserSetting } from '../../../hooks/use-user-setting';

export const useSaveCardCompleteState = (id) => {
  const dispatch = useDispatch();
  const userHomePageFeedCompletedCards = useUserSetting(HomePageFeedCompletedCards) || '[]';
  const completeCard = useCallback(() => {
    const parsedCompletedCards = JSON.parse(userHomePageFeedCompletedCards);
    const isCardAlreadyCompleted = parsedCompletedCards.includes(id);
    if (isCardAlreadyCompleted) {
      return;
    }
    const completedCards = [...parsedCompletedCards, id];
    const completedCardsForSettings = JSON.stringify(completedCards);
    dispatch(
      saveUserSetting({
        settingName: HomePageFeedCompletedCards,
        settingValue: completedCardsForSettings,
        excludeV3prefix: true,
      }),
    );
  }, [dispatch, id, userHomePageFeedCompletedCards]);
  return completeCard;
};
